async function fetchConfigJson(url) {
  const response = await fetch(url, {
    method: "GET",
    headers: {
      Accept: "application/json",
    },
  });

  if (!response.ok) {
    throw new Error(`Request failed: ${response.status} ${response.statusText}`);
  }

  return response.json();
}

export async function fetchClientAppSettings(baseUrl, tenantId) {
  return fetchConfigJson(`${baseUrl}/clients/config/${tenantId}/`);
}


export async function fetchAppConfig(baseUrl, tenantId) {
  return fetchConfigJson(
    `${baseUrl}/app/configs/?tenant_id=${encodeURIComponent(tenantId)}`
  );
}

async function resolveSitePaymentOnly(baseUrl, tenantId) {
  try {
    const clientSettings = await fetchClientAppSettings(baseUrl, tenantId);
    if (clientSettings && clientSettings.is_site_payment_only != null) {
      return !!clientSettings.is_site_payment_only;
    }
  } catch (err) {
    console.warn(
      "[main] clients/config payment-only fetch failed:",
      err.message
    );
  }

  try {
    const appConfig = await fetchAppConfig(baseUrl, tenantId);
    const fromAppConfig = appConfig?.tenant_level_features?.is_site_payment_only;
    if (fromAppConfig != null) {
      return !!fromAppConfig;
    }
  } catch (err) {
    console.warn("[main] app/configs payment-only fetch failed:", err.message);
  }

  return false;
}

export async function mergeSitePaymentOnlySetting(data) {
  const tenantId =
    data?.settings?.generalSettings?.tenantId || data?.settings?.tenantId;
  const baseUrl = data?.base_url;

  if (!tenantId || !baseUrl) {
    return data;
  }

  const isSitePaymentOnly = await resolveSitePaymentOnly(baseUrl, tenantId);

  return {
    ...data,
    settings: {
      ...data.settings,
      generalSettings: {
        ...(data.settings?.generalSettings || {}),
        is_site_payment_only: isSitePaymentOnly,
      },
    },
  };
}
